import { useEffect, useState } from 'react'
import { RecurlyError } from '@recurly/recurly-js'
import { SubscriptionPlans } from '@pff-consumer/schema'
import { usePricing } from '@pff-consumer/feature-account/hooks/subscribe/usePricing'
import { defaultAnnualPrice, defaultMonthlyPrice } from '@pff-consumer/utils'

export const useUpsellPricing = (coupon: string) => {
  const [recurlyMonthlyError, setRecurlyMonthlyError] = useState<RecurlyError>()
  const [recurlyYearlyError, setRecurlyYearlyError] = useState<RecurlyError>()
  // we need promoCode to initialize to '' or our usePricing hook will not return a price
  // for plans which do not support the initial promoCode provided
  const [promoCode, setPromoCode] = useState<string>('')

  const {
    price: annualPlanPrice,
    updatePrice: updateAnnualPrice,
    loading: annualPriceLoading,
  } = usePricing(promoCode, SubscriptionPlans.PREMIUM_ANNUAL, setRecurlyYearlyError)

  const {
    price: monthlyPlanPrice,
    updatePrice: updateMonthlyPrice,
    loading: monthlyPriceLoading,
  } = usePricing(promoCode, SubscriptionPlans.PREMIUM_ANNUAL, setRecurlyMonthlyError)

  useEffect(() => {
    setPromoCode(coupon)
  }, [coupon])

  useEffect(() => {
    updateAnnualPrice(SubscriptionPlans.PREMIUM_ANNUAL, promoCode)
    updateMonthlyPrice(SubscriptionPlans.PREMIUM_MONTHLY_SEASON, promoCode)
    setRecurlyMonthlyError(undefined)
    setRecurlyYearlyError(undefined)
    // Disabled to prevent unnecessary calling of updatePrice function
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [promoCode])

  const isError = recurlyMonthlyError && recurlyYearlyError

  return {
    annualPlanPrice: annualPlanPrice || defaultAnnualPrice,
    annualPriceLoading,
    monthlyPlanPrice: monthlyPlanPrice || defaultMonthlyPrice,
    monthlyPriceLoading,
    isError,
  }
}
